<template>
  <div>
    <view-title>
      <v-icon class="primary--text mr-4">fas fa-search</v-icon> Acervo
      <template slot="button" v-if="hasPermission">
        <v-col class="text-right">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn rounded color="primary" class="font-weight-normal" v-on="on">
                Adicionar
                <v-icon class="ml-2" x-small>
                  fas fa-caret-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :to="{ name: 'Acervo editar', params: { acervo: 'audiovisual' } }">
                <v-list-item-title>Acervo Audiovisual</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Acervo editar', params: { acervo: 'fotografico' } }">
                <v-list-item-title>Acervo Fotográfico</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Acervo editar', params: { acervo: 'textual' } }">
                <v-list-item-title>Acervo Textual</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Acervo editar', params: { acervo: 'depoimentos' } }">
                <v-list-item-title>Depoimento</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Acervo editar', params: { acervo: 'pecas' } }">
                <v-list-item-title>Peças</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Acervo editar', params: { acervo: 'referencia' } }">
                <v-list-item-title>Referências</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </template>
    </view-title>
    <simple-dialog
      title="Excluir"
      icon="fa-exclamation-triangle"
      :text="
        `Você tem certeza que deseja
                   excluir ${deleteItem.nome}?`
      "
      confirmText="Excluir"
      :dialog="deleteDialog"
      :on-dialog-input="onDeleteDialogInput"
      :on-confirm="onDelete"
      :loading="loading"
    />
    <simple-dialog
      title="Excluir"
      icon="fa-exclamation-triangle"
      :text="
        `Você tem certeza que deseja
          excluir ${bulkDeleteItems.length}
          ${bulkDeleteItems.length == 1 ? 'item' : 'itens'}?`
      "
      confirmText="Excluir"
      :dialog="bulkDeleteDialog"
      :on-dialog-input="onBulkDeleteDialogInput"
      :on-confirm="onBulkDelete"
      :loading="loading"
    />
    <simple-dialog
      title="Ocultar"
      icon="fa-exclamation-triangle"
      :text="
        `Você tem certeza que deseja
         ocultar ${bulkDeleteItems.length}
         ${bulkDeleteItems.length == 1 ? 'item' : 'itens'}?`
      "
      confirmText="Ocultar"
      :dialog="bulkHideDialog"
      :on-dialog-input="onBulkHideDialogInput"
      :on-confirm="onBulkHide"
      :loading="loading"
    />
    <register-dialog
      :dialog="registerDialog"
      :register-account="registerAccount"
      :on-register-dialog-input="onRegisterDialogInput"
      :on-register-account-patch="onRegisterAccountPatch"
      :on-register="onRegister"
      :loading="registerLoading"
    />
    <v-container fluid>
      <div v-if="searchType === 'simple'">
        <collection-simple-search
          :collections="collections"
          :on-search="onSimpleSearch"
          :on-search-type-change="onSearchTypeChange"
          :is-admin="isAdmin"
          :on-patch-filter="onPatchFilter"
          :filter="filter"
          :accounts="accounts"
          v-if="hasPermission"
        />
        <collection-simple-search-pesquisador
          :collections="collections"
          :on-search="onSimpleSearch"
          :on-search-type-change="onSearchTypeChange"
          :is-admin="isAdmin"
          :on-patch-filter="onPatchFilter"
          :filter="filter"
          v-if="!hasPermission"
        />

        <v-row class="mx-5" v-if="showTable">
          <v-col cols="12" sm="2">
            <collection-sidebar-filters
              :collections="collections"
              :segmentos="segmentos"
              :idiomas="idiomas"
              :on-sidebar-filter="onSidebarFilter"
              :filter="filter"
            />
          </v-col>
          <v-col cols="12" sm="10">
            <v-data-table
              @input="onSetBulkDeleteItems"
              :value="bulkDeleteItems"
              :headers="headers"
              :items="items"
              :options="options"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="footerProps"
              :show-select="hasPermission"
              @update:options="loadItems({ $event, $vuetify })"
              class="elevation-1 px-5 pt-2"
              loading-text="Carregando consulta... Por favor, aguarde."
              id="search-result"
            >
              <template v-slot:top v-if="bulkDeleteItems.length">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      class="mx-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="onBulkHideDialogOpen(bulkDeleteItems)"
                    >
                      <v-icon x-small class="accent--text">fas fa-eye-slash</v-icon>
                    </v-btn>
                  </template>
                  <span>Ocultar itens selecionados</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      class="mx-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="onBulkDeleteDialogOpen(bulkDeleteItems)"
                    >
                      <v-icon x-small class="red--text">fas fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar itens selecionados</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.registro`]="{ item }">
                <div class="cursor" @click="onOpenItem(item)">
                  <span>{{ item.registro }}</span>
                </div>
              </template>
              <template v-slot:[`item.publicador`]="{ item }" v-if="hasPermission">
                <div class="cursor" @click="onOpenItem(item)">
                  <span>{{ item.publicador }}</span>
                </div>
              </template>
              <template v-slot:[`item.nome`]="{ item }">
                <div class="cursor" @click="onOpenItem(item)">
                  <v-tooltip top v-if="item.nome && item.nome.trim().length > 70">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        `${item && item.nome && item.nome.trim().substring(0, 70)}${
                          item && item.nome && item.nome.trim().length > 70 ? "..." : ""
                        }`
                      }}</span>
                    </template>
                    <span>{{ item.nome && item.nome.trim() }}</span>
                  </v-tooltip>
                  <span v-else>{{ item.nome && item.nome.trim() }}</span>
                </div>
              </template>
              <!-- <template v-slot:[`item.createdAt`]="{ item }" v-if="hasPermission">
                <div class="cursor" @click="onOpenItem(item)">
                  <span>{{ formatDateDDMMYYYYHHss(item.createdAt) }}</span>
                </div>
              </template> -->
              <template v-slot:[`item.dt_imagem`]="{ item }">
                <div class="cursor" @click="onOpenItem(item)">
                  {{ formatDateAsDayMonthAndYearUTC(item.dtImagem) }}
                  <span v-if="item.dtLimite && item.dtLimite.trim()">-</span>
                  {{ formatDateAsDayMonthAndYearUTC(item.dtLimite) }}
                </div>
              </template>
              <template v-slot:[`item.id_tipo_publicacao`]="{ item }">
                <div class="cursor" @click="onOpenItem(item)">
                  <span>{{ item.idTipoPublicacao }}</span>
                </div>
              </template>
              <template v-slot:[`item.status_fluxo`]="{ item }" v-if="hasPermission">
                <div class="cursor" @click="onOpenItem(item)">
                  <v-chip x-small :color="status(item.statusFluxo).color">
                    {{ status(item.statusFluxo).nome }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.localizacaoFisica`]="{ item }" v-if="hasPermission">
                <div class="cursor" @click="onOpenItem(item)">
                  <v-tooltip top v-if="item.localizacaoFisica.length > 22">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        `${item.localizacaoFisica.substring(0, 22)}${
                          item.localizacaoFisica.length > 22 ? "..." : ""
                        }`
                      }}</span>
                    </template>
                    <span v-if="item.localizacaoFisica.length > 22">{{
                      item.localizacaoFisica
                    }}</span>
                  </v-tooltip>
                  <span v-else>{{ item.localizacaoFisica }}</span>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div v-if="hasPermission">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fas fa-ellipsis-v</v-icon>
                    </template>
                    <v-list>
                      <v-list-item
                        :to="{
                          name: 'Acervo editar',
                          params: {
                            acervo: item.url,
                            id: item.id
                          }
                        }"
                      >
                        <v-list-item-title>
                          <v-icon x-small class="accent--text">fas fa-edit</v-icon> Editar
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="onDeleteDialogOpen(item)">
                        <v-list-item-title>
                          <v-icon x-small class="red--text">fas fa-trash</v-icon> Deletar
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="item.arquivo && item.arquivo.nomeInterno"
                        @click="onOpenFile(item)"
                      >
                        <v-list-item-title>
                          <v-icon x-small class="accent--text">fas fa-eye</v-icon> Visualizar
                          arquivo
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div v-else>
                  <a
                    v-if="item.arquivo && item.arquivo.nomeInterno"
                    @click="onOpenFile(item)"
                    style="z-index: 9999"
                  >
                    Visualizar arquivo
                  </a>
                </div>
              </template>
              <template v-slot:no-data>
                Nenhum registro foi encontrado. Verifique a ortografia e tente novamente.
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="mx-5 mt-10" v-if="!showTable">
          <collection-search-grid
            :has-permission="hasPermission"
            :on-sidebar-filter="onSidebarFilter"
            :collections="collections"
          />
        </v-row>
      </div>
      <div v-if="searchType === 'advanced'">
        <collection-advanced-search
          :on-patch-filter="onPatchFilter"
          :filter="filter"
          :on-search-type-change="onSearchTypeChange"
          :suportes="suportes"
          :idiomas="idiomas"
          :segmentos="segmentos"
          :collections="collections"
          :on-advanced-search="onAdvancedSearch"
          :has-permission="hasPermission"
        />
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import viewTitle from '@/components/view-title.vue';
import simpleDialog from '@/components/simple-dialog.vue';
import registerDialog from '@/components/register-dialog.vue';
import collectionSimpleSearch from '@/components/collection-simple-search.vue';
import collectionSimpleSearchPesquisador from '@/components/collection-simple-search-pesquisador.vue';
import collectionAdvancedSearch from '@/components/collection-advanced-search.vue';
import collectionSearchGrid from '@/components/collection-search-grid.vue';
import collectionSidebarFilters from '@/components/collection-sidebar-filters.vue';
import status from '@/mixins/status';
import dateFormatter from '@/mixins/date-formatter';

export default {
  components: {
    viewTitle,
    simpleDialog,
    collectionSimpleSearch,
    collectionSimpleSearchPesquisador,
    collectionAdvancedSearch,
    collectionSearchGrid,
    collectionSidebarFilters,
    registerDialog,
  },
  mixins: [status, dateFormatter],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate();
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.onRegisterDialogInput(false);
    next();
  },
  computed: mapGetters('views/collection/list', [
    'account',
    'headers',
    'items',
    'totalItems',
    'loading',
    'registerLoading',
    'options',
    'footerProps',
    'deleteDialog',
    'bulkDeleteDialog',
    'bulkDeleteItems',
    'bulkHideDialog',
    'deleteItem',
    'showTable',
    'collection',
    'collections',
    'searchType',
    'suportes',
    'idiomas',
    'segmentos',
    'registerDialog',
    'registerAccount',
    'hasPermission',
    'isAdmin',
    'isOperador',
    'filter',
    'accounts',
  ]),
  methods: mapActions('views/collection/list', [
    'onInputSearch',
    'loadItems',
    'onDeleteDialogInput',
    'onBulkDeleteDialogInput',
    'onBulkHideDialogInput',
    'onDeleteDialogOpen',
    'onBulkDeleteDialogOpen',
    'onBulkHideDialogOpen',
    'onSetBulkDeleteItems',
    'onDelete',
    'onBulkDelete',
    'onBulkHide',
    'afterRouteUpdate',
    'onSimpleSearch',
    'onAdvancedSearch',
    'onSearchTypeChange',
    'onAdvSelect',
    'onAdvConditional',
    'onRegisterDialogInput',
    'onRegister',
    'onOpenItem',
    'onOpenFile',
    'onRegisterAccountPatch',
    'onSidebarFilter',
    'onPatchFilter',
  ]),
};
</script>
<style scoped>
.cursor {
  cursor: pointer;
}
tbody tr:nth-of-type(even) {
  background-color: #f8f8f8;
}
.theme--light.v-data-table.elevation-1
  >>> tbody
  tr:not(:last-child)
  td:not(.v-data-table__mobile-row) {
  border-bottom: none;
}
.theme--light.v-data-table.elevation-1 >>> thead tr th {
  color: #404040;
}
.theme--light.v-data-table.elevation-1 >>> thead tr:last-child th {
  border-bottom: 1px solid #404040;
}
.theme--light.v-data-table.elevation-1
  >>> .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  margin-left: 5px;
}
</style>
